export * from './lib/interfaces/slider-form-field-config.interface';
export * from './lib/form-slider.module';
